import React from 'react';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { AdPlacementMmaBase } from './mma-ad-placement-base';

import {
  getMmaInMsanWideImage191x100Styles,
  getMmaInMsanSquareImage1x1Styles,
  getMmaInMsanMSEdgeSingleCarousel178x100Styles,
  getMmaInMsanMSNInArticle150x100Styles,
  getMmaInMsanMSNSmallHeadline133x100Styles,
} from '../styles';

export const AdPlacementMmaInMsanWideImage191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    isMultiLineDescription
    showBusinessName
    showBusinessNameAdLabel
  />),
  getMmaInMsanWideImage191x100Styles,
  { componentName: 'AdPlacementMmaInMsanWideImage191x100' }
);

export const AdPlacementMmaInMsanMSEdgeSingleCarousel178x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getMmaInMsanMSEdgeSingleCarousel178x100Styles,
  { componentName: 'AdPlacementMmaInMsanMSEdgeSingleCarousel178x100' }
);

export const AdPlacementMmaInMsanMSNInArticle150x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    isMultiLineDescription
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getMmaInMsanMSNInArticle150x100Styles,
  { componentName: 'AdPlacementMmaInMsanMSNInArticle150x100' }
);

export const AdPlacementMmaInMsanMSNSmallHeadline133x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getMmaInMsanMSNSmallHeadline133x100Styles,
  { componentName: 'AdPlacementMmaInMsanMSNSmallHeadline133x100' }
);

export const AdPlacementMmaInMsanSquareImage1x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getMmaInMsanSquareImage1x1Styles,
  { componentName: 'AdPlacementMmaInMsanSquareImage1x1' }
);
